
import loadingImage from '../assets/loading_blockui.gif'

export const blockScreenUi = {
    blockScreenData: {
        msg: "Aguarde, estamos processando os dados...",
        url: loadingImage
    }
}

export const blockScreenUiSave = {
    blockScreenData: {
        msg: "Registrando os dados...",
        url: loadingImage
    }
}